import React from 'react';

import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import Styles from './EMAProductsReview.styles';
import {
  EMAProductsConfirmationDialog,
  EMAProductsPdfViewer,
  EMAProductsReviewHeader,
  EMAProductsReviewPanel
} from './EMAProductsReview.views';
import useEMAProductsReview from './useEMAProductsReview';

const EMAProductsReviewPage = () => {
  const classes = Styles();
  const model = useEMAProductsReview();
  const { actions, hasCurationIdentity, selectedProduct, state } = model;

  return (
    <Box className={classes.root}>
      <Container maxWidth='lg' className={classes.container}>
        <EMAProductsReviewHeader
          hasCurationIdentity={hasCurationIdentity}
          hasSelectedProduct={Boolean(selectedProduct)}
          loading={state.loading}
          mode={state.mode}
          initialCount={state.initialCount}
          sessionNewCount={state.sessionNewCount}
          onBack={actions.goBack}
          onEdit={actions.startEdit}
          onAdd={actions.startAdd}
          onDone={actions.requestDone}
        />

        <Grid container spacing={2}>
          <Grid item xs={12} lg={4}>
            <EMAProductsReviewPanel model={model} />
          </Grid>
          <Grid item xs={12} lg={8}>
            <EMAProductsPdfViewer pdfUrl={state.pdfUrl} />
          </Grid>
        </Grid>

        <EMAProductsConfirmationDialog
          dialog={state.dialog}
          onClose={actions.closeDialog}
          onConfirm={actions.confirmDialog}
        />
      </Container>
    </Box>
  );
};

export default EMAProductsReviewPage;
